import { render } from "./ConsultForm.vue?vue&type=template&id=21eff480"
import script from "./ConsultForm.vue?vue&type=script&lang=js"
export * from "./ConsultForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__